import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import MasterContext from 'context';
import Challenge from 'layouts/challenge';
import Charge from 'layouts/charge';
import DisputeChat from 'layouts/dispute';
import LinkPage from 'layouts/link';
import SharedLinkPage from 'layouts/shared';
import UnsubscribePage from 'layouts/unsubscribe';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './assets/css/App.css';
import AdminLayout from './layouts/access';
import AuthLayout from './layouts/auth';
import theme from './theme/theme';

// Redirect legacy hash-based URLs (e.g. /#/charge/uuid) to clean URLs (/charge/uuid)
if (window.location.hash.startsWith('#/')) {
  const path = window.location.hash.slice(1); // remove the '#'
  window.history.replaceState(null, '', path + window.location.search);
}

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

export const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ChakraProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <React.StrictMode>
        <BrowserRouter>
          <Routes>
            <Route path={`/charge/:id`} element={<Charge />} />
            <Route path={`/link/:id`} element={<LinkPage />} />
            <Route path={`/dispute/:id`} element={<DisputeChat />} />
            <Route path={`/unsubscribe`} element={<UnsubscribePage />} />
            <Route path={`/shared/:id`} element={<SharedLinkPage />} />
            <Route path={`/challenge`} element={<Challenge />} />
            <Route path="/" element={<Navigate to="/access" replace />} />
            <Route
              path={`/auth/*`}
              element={
                <MasterContext>
                  <AuthLayout />
                </MasterContext>
              }
            />
            <Route
              path={`/access/*`}
              element={
                <MasterContext>
                  <AdminLayout />
                </MasterContext>
              }
            />
          </Routes>
        </BrowserRouter>
      </React.StrictMode>
    </QueryClientProvider>
  </ChakraProvider>,
);
